import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import { Title, StyledText, AlertText } from '../Procedure.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import InputBox from 'src/common/refactoredComponents/input/Input';
import media from 'src/styles/Media.styled';
import styled from 'styled-components';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { PopUpImage } from 'src/common/components/popup/Popup.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { debounce, getShowOrder, logErrorToConsole } from 'src/utils/util';
import { AdvDiv, CheckBoxDiv } from './AdditionalProcedureData.styled';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import { useTranslation } from 'react-i18next';
import {
    getDropdownValues,
    loadAllCaseCoverageLoading,
} from 'src/pages/scheduleSurgery/redux/actions';
import MazorCaseCoverageTemplate from 'src/pages/reportUsage/procedure/components/mazorCaseCoverageTemplate/MazorCaseCoverageTemplate';
import {
    setMazorCaseCoverageValue,
    setProcedureData,
    setStealthCaseCoverageValue,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    FONT_FAMILY_REGULAR,
    BLACK_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    WHITE_FONT_COLOR,
    SMALL_TEXT_PX,
    XX_SMALL_TEXT_PX,
    BASE_TEXT_PX,
} from 'src/styles/fonts/MCFontConstants';
import {
    VISIBLE
} from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const AdditionalProcedureDesktop = ({
    // --- Data and State ---
    additionalProcedureData,
    procedureData,
    procedureInfoData,
    setProcedureInfoData,
    progressBarClicked,
    condensedViewPadding,
    FIELD_ORDER,

    // --- Handlers ---
    radioButtonChangeHandler,
    checkboxSelectionChangeHandler,

    // --- Advanced Energy ---
    advancedEnergyCheck,
    advanceEnergyProduct,

    // --- MazorX Robot Used ---
    mazorRoboticsCode,
    mazorxChecked,
    mazorCodeValidator,
    mazorCodeValidatorOnBlur,
    validateMazorCodeRes,
    setMazorCaseCoverageInputValue,
    mazorCaseCoverageInputValue,
    selectedMazorCaseCoverage,
    setSelectedMazorCaseCoverage,
    noUsageToReportMycaseRefId,
    reportProcedureMycaseRefId,

    // --- Stealth AXiS ---
    // --- Stealth AXiS ---

    stealthAxisChecked,
    stealthAxisCode,
    setStealthAxisCode,
    stealthAxisAutoPilot = null,
    setStealthAxisAutoPilot = () => {},
    stealthAxisLiveAlign = null,
    setStealthAxisLiveAlign = () => {},
    setStealthAxisCaseCoverageInputValue,
    stealthAxisCaseCoverageInputValue,
    setSelectedStealthAxisCaseCoverage = () => {},
    selectedStealthAxisCaseCoverage,
    stealthAxisCodeError,
    setStealthAxisCodeError,
    stealthCodeValidatorOnBlur,
    reportUsageStealthAutoPilotVisibility,
    reportUsageStealthLiveAlignVisibility,
    equityStealthAutoPilotVisibility,
    equityStealthLiveAlignVisibility,

    // --- UI/Styling ---
    errorBorderColor,
    imageMarginLeftDesktop,
    imgRightToTextMarginLeft,
    imgRightToText,
    isFromEquity,
}) => {
    const isEquity = false;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const mazorCaseCoverageRef = useRef();
    const stealthCaseCoverageRef = useRef();
    const winWidth = window.innerWidth;
    const isDesktopView = winWidth > sizes.mediumDevice;
    const isTabletView =
        winWidth >= sizes.smalDevice && winWidth <= sizes.mediumDevice;
    const [, setShowOrder] = useState(showOrderNonJapan);
    const isMobileView = winWidth < sizes.smalDevice;

    const showOrderNonJapan = {
        Powerease: 1,
        'Stealth S7/S8 Navigation': 3,
        'Advanced Energy': 5,
        'MazorX Robot Used': 2,
    };

    const [stealthAxisDropdown, setStealthAxisDropdown] = useState(false);
    const [mazorCaseCoverageDropdown, setMazorCaseCoverageDropdown] =
        useState(false);

    useEffectWithErrorLogging(() => {
        if (additionalProcedureData.length < 4) {
            setShowOrder(getShowOrder(additionalProcedureData));
        } else {
            setShowOrder(showOrderNonJapan);
        }
    }, [progressBarClicked]);

    // const closekeyBoard = () => {
    //     document.activeElement.blur();
    // };

    const {
        mazorstate,
        mazorCaseCoverage,
        mazorCaseCoverageOptionLoading,
        stealthCaseCoverage,
    } = useSelector((state) => ({
        mazorCaseCoverageOptionLoading:
            state.detailsDropdownsReducer.mazorCaseCoverageEmployees.loading,
        mazorstate:
            state.detailsDropdownsReducer.mazorCaseCoverageEmployees?.items,
        mazorCaseCoverage: state.reportUsageRootReducer.mazorCaseCoverage,
        stealthCaseCoverage: state.reportUsageRootReducer.stealthCaseCoverage,
    }));

    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );
    useEffectWithErrorLogging(() => {
        // Deep clone additionalProcedureData to avoid mutation
        const addProcData = [
            ...(procedureData?.additionalProcedure ||
                additionalProcedureData ||
                []),
        ];

        const mazorxIdx = addProcData?.findIndex(
            (x) => x.description === 'MazorX Robot Used' && x.isSelected
        );
        if (
            mazorCaseCoverage !== '' &&
            mazorCaseCoverage !== null &&
            mazorCaseCoverage !== undefined
        ) {
            dispatch(setMazorCaseCoverageValue(selectedMazorCaseCoverage));
            setSelectedMazorCaseCoverage(selectedMazorCaseCoverage);
        } else {
            dispatch(setMazorCaseCoverageValue(''));
            setSelectedMazorCaseCoverage('');
            if (mazorxIdx > 0) {
                addProcData[mazorxIdx].mazorCaseCoverage = '';
            }
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
    }, [selectedMazorCaseCoverage]);

    useEffectWithErrorLogging(() => {
        // Deep clone additionalProcedureData to avoid mutation
        const addProcData = [
            ...(procedureData?.additionalProcedure ||
                additionalProcedureData ||
                []),
        ];

        const mazorxIdx = addProcData?.findIndex(
            (x) => x.description === 'Stealth AXiS' && x.isSelected
        );
        if (
            stealthCaseCoverage !== '' &&
            stealthCaseCoverage !== null &&
            stealthCaseCoverage !== undefined
        ) {
            dispatch(
                setStealthCaseCoverageValue(selectedStealthAxisCaseCoverage)
            );
            setSelectedStealthAxisCaseCoverage(selectedStealthAxisCaseCoverage);
        } else {
            dispatch(setStealthCaseCoverageValue(''));
            setSelectedStealthAxisCaseCoverage('');
            if (mazorxIdx > 0) {
                addProcData[mazorxIdx].stealthCaseCoverage = '';
            }
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
    }, [selectedStealthAxisCaseCoverage]);
    useEffectWithErrorLogging(() => {
        const addProcData = [
            ...(procedureData?.additionalProcedure ||
                additionalProcedureData ||
                []),
        ];
        const axisIdx = addProcData.findIndex(
            (x) => x.description === 'Stealth AXiS' && x.isSelected
        );
        if (axisIdx >= 0) {
            addProcData[axisIdx].stealthAxisCode = stealthAxisCode;
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
    }, [stealthAxisCode]);

    useEffectWithErrorLogging(() => {
        if (typeof stealthAxisAutoPilot !== 'boolean') return;
        const addProcData = [
            ...(procedureData?.additionalProcedure ||
                additionalProcedureData ||
                []),
        ];
        const axisIdx = addProcData.findIndex(
            (x) => x.description === 'Stealth AXiS' && x.isSelected
        );
        if (axisIdx >= 0) {
            const newValue = stealthAxisAutoPilot;
            const existingValue =
                procedureInfoData?.additionalProcedure?.find(
                    (x) => x.description === 'Stealth AXiS' && x.isSelected
                )?.stealthAxisAutoPilot ?? null;
            if (existingValue === newValue) return;
            addProcData[axisIdx] = {
                ...addProcData[axisIdx],
                stealthAxisAutoPilot: newValue,
            };
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
    }, [stealthAxisAutoPilot]);

    useEffectWithErrorLogging(() => {
        if (typeof stealthAxisLiveAlign !== 'boolean') return;
        const addProcData = [
            ...(procedureData?.additionalProcedure ||
                additionalProcedureData ||
                []),
        ];
        const axisIdx = addProcData.findIndex(
            (x) => x.description === 'Stealth AXiS' && x.isSelected
        );
        if (axisIdx >= 0) {
            const newValue = stealthAxisLiveAlign;
            const existingValue =
                procedureInfoData?.additionalProcedure?.find(
                    (x) => x.description === 'Stealth AXiS' && x.isSelected
                )?.stealthAxisLiveAlign ?? null;
            if (existingValue === newValue) return;
            addProcData[axisIdx] = {
                ...addProcData[axisIdx],
                stealthAxisLiveAlign: newValue,
            };
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
    }, [stealthAxisLiveAlign]);
    const handleLoadAll = (loadAnimation, isFromStealthAxis) => {
        // setPhysicianValue('');
        !isFromStealthAxis && dispatch(setMazorCaseCoverageValue(''));
        isFromStealthAxis && dispatch(setStealthCaseCoverageValue(''));
        dispatch(
            loadAllCaseCoverageLoading(loadAnimation ? loadAnimation : false)
        );
        getMazorCaseList({
            searchValue: '',
            loadAll: true,
        });
    };

    const getMazorCaseList = (data) => {
        const { searchValue, loadAll } = data;
        const params = {
            isLoadAll: loadAll,
            sstRef: noUsageToReportMycaseRefId
                ? noUsageToReportMycaseRefId
                : reportProcedureMycaseRefId
                ? reportProcedureMycaseRefId
                : myCaseRefId,
            searchParam: searchValue ? searchValue : '',
        };
        params?.sstRef &&
            params?.sstRef.length > 0 &&
            dispatch(
                getDropdownValues({
                    dropDownName: 'mazorCaseCoverageEmployees',
                    value: params,
                })
            );
    };

    const handleInputChange = (name, value, isFrom) => {
        if (value === '') {
            !isFrom && dispatch(setMazorCaseCoverageValue(''));
            isFrom && dispatch(setStealthCaseCoverageValue(''));
        }
        getMazorCaseList({
            searchValue: '',
            isLoadAll: true,
        });
    };

    const handleOnfocus = (event, field) => {
        if (field == 'mazorCaseCoverage') {
            getMazorCaseList({
                searchValue: event?.target?.value?.trim() || '',
                loadAll: false,
                type: 'All',
            });
        }
    };

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;

    const handleSearch = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            const option = {
                searchValue: value?.trim() || '',
                sstRef: myCaseRefId,
            };
            if (fieldname == 'mazorCaseCoverage') {
                setMazorCaseCoverageInputValue(value);
                debouncedGetList(getMazorCaseList, option);
                setMazorCaseCoverageDropdown(true);
            }
            if (fieldname == 'stealthCaseCoverage') {
                setStealthAxisCaseCoverageInputValue(value);
                debouncedGetList(getMazorCaseList, option);
                setStealthAxisDropdown(true);
            }
        }
    };

    const MazorAutoCompleteChangeHandler = (value, reason, isFromAxis) => {
        // closekeyBoard();
        if (isFromAxis) {
            if (reason === 'clear') {
                getMazorCaseList({
                    searchValue: '',
                    sstRef: myCaseRefId,
                    isLoadAll: false,
                });
            }
            // showOptionsAfterClose('mazorCaseCoverage', true);
            //stealthCaseCoverageRef.current?.focus();
            // }
            const addProcData = [...additionalProcedureData];
            const mazorxIdx = addProcData.findIndex(
                (x) => x.description === 'Stealth AXiS' && x.isSelected
            );
            if (value && mazorxIdx >= 0) {
                setStealthAxisCaseCoverageInputValue(
                    value?.caseCoverageFormattedName
                );
                setSelectedStealthAxisCaseCoverage(value);
                getMazorCaseList({
                    searchValue: value?.caseCoverageFormattedName?.trim() || '',
                    sstRef: myCaseRefId,
                    isLoadAll: false,
                });
                addProcData[mazorxIdx].stealthCaseCoverage =
                    value?.caseCoverageFormattedName;
                dispatch(setStealthCaseCoverageValue(value));
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        additionalProcedure: addProcData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: addProcData,
                }));
            } else {
                setStealthAxisCaseCoverageInputValue('');
                setSelectedStealthAxisCaseCoverage('');
                addProcData[mazorxIdx].stealthCaseCoverage = null;
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        additionalProcedure: addProcData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: addProcData,
                }));
                dispatch(setStealthCaseCoverageValue(null));
                getMazorCaseList({
                    searchValue: '',
                    sstRef: myCaseRefId,
                    isLoadAll: false,
                });
                setStealthAxisDropdown(true);
            }
            handleInputChange('caseCoverageEmployeeId', value, true);
            //   if (value === '')
            //   handleDisableField('caseCoverageEmployeeId', value, true);
        } else {
            if (reason === 'clear') {
                handleOnfocus(null, 'mazorCaseCoverage');
                handleSearch('', '', reason, 'mazorCaseCoverage');
            }
            const addProcData = [...additionalProcedureData];
            const mazorxIdx = addProcData.findIndex(
                (x) => x.description === 'MazorX Robot Used' && x.isSelected
            );
            if (value && mazorxIdx >= 0) {
                setMazorCaseCoverageInputValue(
                    value?.caseCoverageFormattedName
                );
                setSelectedMazorCaseCoverage(value);
                getMazorCaseList({
                    searchValue: value?.caseCoverageFormattedName?.trim() || '',
                    sstRef: myCaseRefId,
                    isLoadAll: false,
                });
                addProcData[mazorxIdx].mazorCaseCoverage =
                    value?.caseCoverageFormattedName;
                dispatch(setMazorCaseCoverageValue(value));
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        additionalProcedure: addProcData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: addProcData,
                }));
            } else {
                setMazorCaseCoverageInputValue('');
                setSelectedMazorCaseCoverage('');
                addProcData[mazorxIdx].mazorCaseCoverage = null;
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        additionalProcedure: addProcData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: addProcData,
                }));
                dispatch(setMazorCaseCoverageValue(null));
                setMazorCaseCoverageDropdown(true);
            }
            handleInputChange('caseCoverageEmployeeId', value);
        }
    };

    const visibleFields = FIELD_ORDER.map((desc) =>
        additionalProcedureData.find(
            (f) => f.description === desc && f.isVisible !== false
        )
    ).filter(Boolean);

    // --- SUBOPTION RENDERING ---
    const showMazorRoboticsKitCode = () => (
        <Grid container spacing={2} style={{ marginTop: 0 }}>
            <Grid item xs={12} md={isEquity ? 7 : 12}>
                <Title
                    color={SECONDARY_FONT_COLOR}
                    style={{
                        marginLeft: isDesktopView && isEquity ? '20px' : '0px',
                        marginTop: isDesktopView ? '10px' : '0px',
                    }}
                >
                    <span>Mazor Robotics Kit Code</span>
                    <span className="asterisk">*</span>
                </Title>
            </Grid>
            <Grid item xs={12} md={isEquity ? 5 : 12}>
                <InputBox
                    placeholder={'Enter the Mazor Robotics Kit Code'}
                    width={
                        isDesktopView
                            ? isFromEquity
                                ? '360px'
                                : Math.max(window.innerWidth) >= 1060 &&
                                  Math.max(window.innerWidth) <= 1110 &&
                                  Math.min(window.innerHeight) >= 670 &&
                                  Math.min(window.innerHeight) <= 820
                                ? '420px'
                                : '475px'
                            : isTabletView
                            ? '50%'
                            : '94%'
                    }
                    widthMob={'94%'}
                    border={
                        validateMazorCodeRes &&
                        validateMazorCodeRes.statusCode !== '10723' &&
                        validateMazorCodeRes.statusCode !== 'draft' &&
                        '2px solid #FACFD6'
                    }
                    consignmentBillingBorder={errorBorderColor}
                    maxLength={11}
                    value={mazorRoboticsCode}
                    id={
                        'common-additionalProcedureData-additionalProcedureDesktop-mazorRoboticsCode'
                    }
                    onChange={mazorCodeValidator}
                    onBlur={mazorCodeValidatorOnBlur}
                    marginBottom={'0px'}
                    marginRight={
                        isDesktopView ? (isEquity ? '6rem' : '0px') : '0px'
                    }
                />
            </Grid>
            {validateMazorCodeRes &&
                validateMazorCodeRes.statusCode !== '10723' &&
                validateMazorCodeRes.statusDescription && (
                    <Grid
                        item
                        xs={12}
                        md={isEquity ? 5 : 12}
                        style={{ paddingTop: '0px' }}
                    >
                        <MazorValidateContainer
                            style={{
                                justifyContent:
                                    winWidth <= sizes.mobileDevice
                                        ? 'flex-start'
                                        : '',
                            }}
                            justifyContent={
                                validateMazorCodeRes.statusDescription ===
                                'Invalid Mazor Robotics Kit Code'
                                    ? 'flex-end'
                                    : 'flex-start'
                            }
                        >
                            <AlertText
                                width={
                                    validateMazorCodeRes.statusDescription ===
                                    'Invalid Mazor Robotics Kit Code'
                                        ? '48%'
                                        : '100%'
                                }
                                style={{
                                    width:
                                        winWidth <= sizes.mobileDevice
                                            ? '100%'
                                            : '330px',
                                    margin:
                                        winWidth <= sizes.mobileDevice
                                            ? '0'
                                            : '0',
                                }}
                                justifyContent={'flex-end'}
                            >
                                {imgRightToText ? (
                                    <PopUpImage
                                        marginLeftDesktop={
                                            imageMarginLeftDesktop
                                        }
                                        width={'20px'}
                                        height={'20px'}
                                        marginLeftMobile={
                                            imgRightToTextMarginLeft
                                        }
                                        img={AlertCircleOutline}
                                    ></PopUpImage>
                                ) : null}
                                {validateMazorCodeRes.statusDescription
                                    .toLowerCase()
                                    .includes('invalid mazor code')
                                    ? 'Invalid Mazor Robotics Kit Code'
                                    : validateMazorCodeRes.statusDescription.replace(
                                          /,/,
                                          ''
                                      )}
                            </AlertText>
                        </MazorValidateContainer>
                    </Grid>
                )}
            <Grid item xs={12} md={isEquity ? 7 : 12}>
                <Title
                    style={{
                        marginLeft: isDesktopView && isEquity ? '20px' : '0px',
                        marginTop: '0px',
                    }}
                    color={SECONDARY_FONT_COLOR}
                >
                    <span>Mazor Case Coverage</span>
                    <span className="asterisk">*</span>
                </Title>
            </Grid>
            <Grid item xs={12} md={isEquity ? 5 : 12}>
                <AutoComplete
                    showScrollBar={true}
                    disableClearable={false}
                    id={'mazorCaseCoverage'}
                    style={{
                        width:
                            winWidth < sizes.mobileDevice
                                ? '94%'
                                : isTabletView
                                ? '50%'
                                : isFromEquity
                                ? '360px'
                                : Math.max(window.innerWidth) >= 1060 &&
                                  Math.max(window.innerWidth) <= 1110 &&
                                  Math.min(window.innerHeight) >= 670 &&
                                  Math.min(window.innerHeight) <= 820
                                ? '420px'
                                : '475px',
                    }}
                    isFromMazorCase={true}
                    inputRef={mazorCaseCoverageRef}
                    noOptionStyle={true}
                    value={
                        isEquity ? mazorCaseCoverage : selectedMazorCaseCoverage
                    }
                    options={mazorstate ? mazorstate : ''}
                    onFocus={(event) =>
                        handleOnfocus(event, 'mazorCaseCoverage')
                    }
                    itemTemplate={(option) => (
                        <MazorCaseCoverageTemplate
                            option={option}
                            fieldname={'mazorCaseCoverage'}
                            onLoadMore={() => handleLoadAll(true, false)}
                        />
                    )}
                    placeholder={'Select Mazor Case Coverage'}
                    field="caseCoverageFormattedName"
                    filterField="caseCoverageFormattedName"
                    noOptionsText={
                        mazorCaseCoverage?.length >= 1 ? null : 'Data not found'
                    }
                    optionValue="caseCoverageFormattedName"
                    onChange={(value, reason) =>
                        MazorAutoCompleteChangeHandler(value, reason)
                    }
                    loading={mazorCaseCoverageOptionLoading}
                    onInputChange={(event, value, reset) => {
                        if (value) {
                            handleSearch(
                                event,
                                value,
                                reset,
                                'mazorCaseCoverage'
                            );
                        } else if (reset === 'clear') {
                            handleSearch('', '', reset, 'mazorCaseCoverage');
                        }
                    }}
                    inputValue={
                        isEquity
                            ? mazorCaseCoverage?.caseCoverageFormattedName
                            : mazorCaseCoverageInputValue
                    }
                    readOnly={
                        isEquity ? mazorCaseCoverage : selectedMazorCaseCoverage
                    }
                    marginLeft={'1.5px'}
                    zIndex={9999999}
                    onOpen={() => {
                        try {
                            setMazorCaseCoverageDropdown(true);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onClose={() => {
                        try {
                            setMazorCaseCoverageDropdown(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    open={
                        (
                            isEquity
                                ? mazorCaseCoverage
                                : selectedMazorCaseCoverage
                        )
                            ? false
                            : mazorCaseCoverageDropdown
                    }
                />
            </Grid>
        </Grid>
    );

    const showStealthAxisKitCode = () => {
        return (
            <Grid container spacing={2} style={{ marginTop: 0 }}>
                <Grid item xs={12} md={isEquity ? 7 : 12}>
                    <Title color={SECONDARY_FONT_COLOR}>
                        <span>
                            {t(
                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisCode'
                            )}
                        </span>
                        <span className="asterisk">*</span>
                    </Title>
                </Grid>
                <Grid item xs={12} md={isEquity ? 5 : 12}>
                    <InputBox
                        placeholder={t(
                            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.placeHolder'
                        )}
                        width={
                            isDesktopView
                                ? isFromEquity
                                    ? '360px'
                                    : '475px'
                                : isTabletView
                                ? '50%'
                                : '94%'
                        }
                        widthMob={'94%'}
                        consignmentBillingBorder={errorBorderColor}
                        maxLength={6}
                        value={stealthAxisCode}
                        id={
                            'common-additionalProcedureData-additionalProcedureDesktop-stealthAxisCode'
                        }
                        onChange={(e) => {
                            const value = e.target.value;
                            setStealthAxisCode(value);
                            if (stealthAxisCodeError)
                                setStealthAxisCodeError('');
                        }}
                        onBlur={(e) => {
                            stealthCodeValidatorOnBlur(e);
                            if (
                                stealthAxisCode &&
                                !/^[A-Za-z0-9]{6}$/.test(stealthAxisCode)
                            ) {
                                setStealthAxisCodeError(
                                    t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.invalidMsg'
                                    )
                                );
                            } else {
                                setStealthAxisCodeError('');
                            }
                        }}
                        marginBottom={'5px'}
                        marginRight={
                            isDesktopView ? (isEquity ? '6rem' : '0px') : '0px'
                        }
                    />
                    {stealthAxisCodeError && (
                        <AlertText
                            width={'100%'}
                            style={{
                                color: '#E40A1A',
                                fontSize: SMALL_TEXT_PX,
                                marginTop: '4px',
                                marginBottom: '0',
                            }}
                        >
                            {stealthAxisCodeError}
                        </AlertText>
                    )}
                </Grid>
                <Grid item xs={12} md={isEquity ? 7 : 12}>
                    <Title color={SECONDARY_FONT_COLOR}>
                        <span>
                            {t(
                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisCaseCoverage'
                            )}
                        </span>
                        <span className="asterisk">*</span>
                    </Title>
                </Grid>
                <Grid item xs={12} md={isEquity ? 5 : 12}>
                    <AutoComplete
                        showScrollBar={true}
                        disableClearable={false}
                        id={'stealthAxisCaseCoverage'}
                        style={{
                            width:
                                winWidth <= sizes.mobileDevice
                                    ? '94%'
                                    : isTabletView
                                    ? '50%'
                                    : isFromEquity
                                    ? '360px'
                                    : '475px',
                        }}
                        isFromMazorCase={true}
                        inputRef={stealthCaseCoverageRef}
                        noOptionStyle={true}
                        value={selectedStealthAxisCaseCoverage}
                        options={mazorstate}
                        onFocus={(event) =>
                            handleOnfocus(event, 'mazorCaseCoverage')
                        }
                        itemTemplate={(option) => (
                            <MazorCaseCoverageTemplate
                                option={option}
                                fieldname={'stealthAxisCaseCoverage'}
                                onLoadMore={() => handleLoadAll(true, true)}
                            />
                        )}
                        placeholder={'Select Case Coverage'}
                        field="caseCoverageFormattedName"
                        filterField="caseCoverageFormattedName"
                        noOptionsText={
                            mazorCaseCoverage?.length >= 1
                                ? null
                                : 'Data not found'
                        }
                        optionValue="caseCoverageFormattedName"
                        onChange={(value, reason) =>
                            MazorAutoCompleteChangeHandler(value, reason, true)
                        }
                        loading={mazorCaseCoverageOptionLoading}
                        onInputChange={(event, value, reset) => {
                            if (value) {
                                handleSearch(
                                    event,
                                    value,
                                    reset,
                                    'stealthCaseCoverage'
                                );
                            } else if (reset === 'clear') {
                                handleSearch(
                                    '',
                                    '',
                                    reset,
                                    'stealthCaseCoverage'
                                );
                            }
                        }}
                        onOpen={() => {
                            try {
                                setStealthAxisDropdown(true);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        onClose={() => {
                            try {
                                setStealthAxisDropdown(false);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        open={
                            selectedStealthAxisCaseCoverage
                                ? false
                                : stealthAxisDropdown
                        }
                        readOnly={selectedStealthAxisCaseCoverage}
                        inputValue={stealthAxisCaseCoverageInputValue}
                        marginLeft={'1.5px'}
                        zIndex={9999999}
                        // dropdown={true}
                    />
                </Grid>

                {(reportUsageStealthAutoPilotVisibility === VISIBLE ||
                    equityStealthAutoPilotVisibility === VISIBLE) && (
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                        >
                            <Title color={SECONDARY_FONT_COLOR}>
                                <span>
                                    {t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisAutoPilot'
                                    )}
                                </span>
                                <span className="asterisk">*</span>
                            </Title>
                            <Box display="flex" alignItems="center">
                                <RadioButton
                                    isChecked={stealthAxisAutoPilot === true}
                                    id={'stealthAxisAutoPilot-yes'}
                                    label={t(
                                        'reportUsage.record.reportPayment.ReportPayment.yes'
                                    )}
                                    handleChange={() => {
                                        try {
                                            setStealthAxisAutoPilot(true);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    fontFamilyStyle={FONT_FAMILY_REGULAR}
                                    fontSize={BASE_TEXT_PX}
                                    width={'14px'}
                                />
                                <RadioButton
                                    isChecked={stealthAxisAutoPilot === false}
                                    id={'stealthAxisAutoPilot-no'}
                                    label={t('equity.surgery.notifications.no')}
                                    handleChange={() => {
                                        try {
                                            setStealthAxisAutoPilot(false);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    fontFamilyStyle={FONT_FAMILY_REGULAR}
                                    fontSize={BASE_TEXT_PX}
                                    style={{ paddingLeft: '28px' }}
                                    width={'14px'}
                                />
                            </Box>
                        </Box>
                    </Grid>
                )}

                {(reportUsageStealthLiveAlignVisibility === VISIBLE ||
                    equityStealthLiveAlignVisibility === VISIBLE) && (
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                        >
                            <Title color={SECONDARY_FONT_COLOR}>
                                <span>
                                    {t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisLiveAlign'
                                    )}
                                </span>
                                <span className="asterisk">*</span>
                            </Title>
                            <Box display="flex" alignItems="center">
                                <RadioButton
                                    isChecked={stealthAxisLiveAlign === true}
                                    id={'stealthAxisLiveAlign-yes'}
                                    label={t(
                                        'reportUsage.record.reportPayment.ReportPayment.yes'
                                    )}
                                    handleChange={() => {
                                        try {
                                            setStealthAxisLiveAlign(true);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    fontFamilyStyle={FONT_FAMILY_REGULAR}
                                    fontSize={BASE_TEXT_PX}
                                    width={'14px'}
                                />
                                <RadioButton
                                    isChecked={stealthAxisLiveAlign === false}
                                    id={'stealthAxisLiveAlign-no'}
                                    label={t('equity.surgery.notifications.no')}
                                    handleChange={() => {
                                        try {
                                            setStealthAxisLiveAlign(false);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    fontFamilyStyle={FONT_FAMILY_REGULAR}
                                    fontSize={BASE_TEXT_PX}
                                    style={{ paddingLeft: '28px' }}
                                    width={'14px'}
                                />
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Grid>
        );
    };

    const showCheckboxCode = () => (
        <Grid item xs={12}>
            <AdvDiv
                advancedEnergyCheck={advancedEnergyCheck}
                isEquity={isEquity}
                isDesktopView={isDesktopView}
                isTabletView={isTabletView}
                isMobile={isMobileView}
                condensedViewPadding={condensedViewPadding}
                marginBtm={'0px'}
                paddingLeft={'10px'}
            >
                <Box
                    style={{
                        display: isEquity
                            ? 'flex'
                            : isTabletView
                            ? 'inline-flex'
                            : null,
                        marginTop: '15px',
                        whiteSpace: isEquity ? 'nowrap' : null,
                        flexDirection: isMobileView ? 'column' : null,
                    }}
                >
                    <Title
                        paddingBtm={'10px'}
                        color={SECONDARY_FONT_COLOR}
                        isTab={isTabletView}
                        width={
                            isDesktopView
                                ? '185px'
                                : !isEquity && isTabletView
                                ? '500px'
                                : '0px'
                        }
                        style={{
                            marginLeft: isDesktopView
                                ? isEquity
                                    ? '20px'
                                    : '0px'
                                : isTabletView
                                ? '2%'
                                : '0px',

                            display: 'inline',
                        }}
                    >
                        <span>Advanced Energy Product</span>
                        <span className="asterisk">*</span>
                    </Title>
                    <CheckBoxDiv
                        isEquity={isEquity}
                        isMobile={isMobileView}
                        width={isDesktopView && '100%'}
                    >
                        {advanceEnergyProduct &&
                            advanceEnergyProduct.map((prod, idx) => (
                                <Grid
                                    key={idx}
                                    xs={
                                        isDesktopView ? (isEquity ? 12 : 6) : 12
                                    }
                                    style={{
                                        marginLeft:
                                            prod.description !==
                                                'isAquamantys' && isEquity
                                                ? isTabletView
                                                    ? '-3%'
                                                    : '-1%'
                                                : null,
                                        marginRight:
                                            prod.description ===
                                                'isAquamantys' &&
                                            !isEquity &&
                                            isTabletView
                                                ? '-56px'
                                                : null,
                                    }}
                                >
                                    <div>
                                        <Checkbox
                                            id={prod.description}
                                            checked={prod.isSelected}
                                            label={
                                                prod.description ===
                                                'isAquamantys'
                                                    ? 'Aquamantys'
                                                    : 'PlasmaBlade X'
                                            }
                                            margin={'3px 0 0 22px'}
                                            labelStyleObj={{
                                                fontFamily: FONT_FAMILY_REGULAR,
                                                textAlign: 'left',
                                                fontSize: SMALL_TEXT_PX,
                                                letterSpacing: '-0.12px',
                                                color: BLACK_FONT_COLOR,
                                                opacity: 1,
                                                paddingLeft: XX_SMALL_TEXT_PX,
                                            }}
                                            onCheckboxSelectionChange={(e) =>
                                                checkboxSelectionChangeHandler(
                                                    e,
                                                    'additionalProcedureData',
                                                    idx,
                                                    prod.description
                                                )
                                            }
                                        />
                                    </div>
                                </Grid>
                            ))}
                    </CheckBoxDiv>
                </Box>
            </AdvDiv>
        </Grid>
    );

    // --- DESIGN: Responsive grid, always 2 columns on desktop/tablet, 1 on mobile ---
    return (
        <Box
            my={1}
            bgcolor={WHITE_FONT_COLOR}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            padding={
                isDesktopView
                    ? '20px 32px 24px 22px'
                    : isTabletView
                    ? '20px 32px 24px 22px'
                    : '20px 6px 24px 22px'
            }
            width={'99.66%'}
            position={'relative'}
            marginLeft={'1px'}
            marginRight={'1px'}
            border={
                visibleFields.length > 0 &&
                visibleFields.every((item) =>
                    item.description === 'MazorX Robot Used' && item.isSelected
                        ? item.mazorKitCode &&
                          item.mazorKitCode.length > 0 &&
                          validateMazorCodeRes &&
                          (validateMazorCodeRes.statusCode === '10723' ||
                              validateMazorCodeRes.statusCode === 'draft') &&
                          mazorCaseCoverage !== '' &&
                          mazorCaseCoverage !== null &&
                          mazorCaseCoverage !== undefined
                        : typeof item.isSelected === 'boolean'
                ) &&
                visibleFields.every((item) =>
                    item.description === 'Advanced Energy' && item.isSelected
                        ? Object.values(item.advancedEnergyProduct).includes(
                              true
                          )
                        : typeof item.isSelected === 'boolean'
                ) &&
                (stealthAxisChecked
                    ? stealthAxisCode.length === 6 &&
                      selectedStealthAxisCaseCoverage &&
                      (reportUsageStealthAutoPilotVisibility === VISIBLE || equityStealthAutoPilotVisibility === VISIBLE
                          ? typeof stealthAxisAutoPilot === 'boolean'
                          : true) &&
                      (reportUsageStealthLiveAlignVisibility === VISIBLE || equityStealthLiveAlignVisibility === VISIBLE
                          ? typeof stealthAxisLiveAlign === 'boolean'
                          : true)
                    : true)
                    ? '1px solid #12C8F7'
                    : ''
            }
        >
            <Title
                paddingBtm={isDesktopView ? '20px' : '15px'}
                mbpaddingBtm={'15px'}
                fontSize={BASE_TEXT_PX}
            >
                <span>
                    {t(
                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.title'
                    )}
                </span>
                <span className="asterisk">*</span>
            </Title>
            {visibleFields.length > 0 &&
                (() => {
                    // Check if MazorX Robot Used is selected
                    const mazorXObj = visibleFields.find(
                        (f) => f.description === 'MazorX Robot Used'
                    );
                    const isMazorXSelected = mazorXObj && mazorXObj.isSelected;

                    // If MazorX is selected, split into two columns: left (other fields), right (mazorx)
                    if (isMazorXSelected) {
                        // Left column: all except MazorX
                        const leftFields = visibleFields.filter(
                            (f) => f.description !== 'MazorX Robot Used'
                        );
                        // Right column: MazorX only
                        const rightField = mazorXObj;

                        return (
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={isTabletView ? 12 : 6}>
                                    {leftFields.map((obj, index) => (
                                        <Box
                                            key={obj.code}
                                            mb={!isMobileView && 3}
                                            style={{
                                                marginTop:
                                                    isTabletView &&
                                                    obj?.description ===
                                                        'MazorX Robot Used'
                                                        ? '-12px'
                                                        : undefined,
                                            }}
                                        >
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                mb={2}
                                                padding={
                                                    index === 0 && isDesktopView
                                                        ? '0px'
                                                        : '12px 0px'
                                                }
                                                minHeight={'20px'}
                                            >
                                                <StyledText
                                                    fontSize={SMALL_TEXT_PX}
                                                >
                                                    {obj?.description}
                                                </StyledText>
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                >
                                                    <RadioButton
                                                        isChecked={
                                                            obj.isSelected ===
                                                            true
                                                        }
                                                        id={`reportPayment-yes-${obj?.description}`}
                                                        label={t(
                                                            'reportUsage.record.reportPayment.ReportPayment.yes'
                                                        )}
                                                        handleChange={() => {
                                                            try {
                                                                radioButtonChangeHandler(
                                                                    visibleFields,
                                                                    visibleFields.findIndex(
                                                                        (f) =>
                                                                            f.code ===
                                                                            obj.code
                                                                    ),
                                                                    true
                                                                );
                                                            } catch (error) {
                                                                logErrorToConsole(
                                                                    error
                                                                );
                                                            }
                                                        }}
                                                        fontFamilyStyle={
                                                            FONT_FAMILY_REGULAR
                                                        }
                                                        fontSize={BASE_TEXT_PX}
                                                        width={'14px'}
                                                    />
                                                    <RadioButton
                                                        isChecked={
                                                            obj.isSelected ===
                                                            false
                                                        }
                                                        id={`reportPayment-no-${obj?.description}`}
                                                        label={t(
                                                            'equity.surgery.notifications.no'
                                                        )}
                                                        handleChange={() => {
                                                            try {
                                                                radioButtonChangeHandler(
                                                                    visibleFields,
                                                                    visibleFields.findIndex(
                                                                        (f) =>
                                                                            f.code ===
                                                                            obj.code
                                                                    ),
                                                                    false
                                                                );
                                                            } catch (error) {
                                                                logErrorToConsole(
                                                                    error
                                                                );
                                                            }
                                                        }}
                                                        fontFamilyStyle={
                                                            FONT_FAMILY_REGULAR
                                                        }
                                                        fontSize={BASE_TEXT_PX}
                                                        style={{
                                                            paddingLeft: '28px',
                                                        }}
                                                        width={'14px'}
                                                    />
                                                </Box>
                                            </Box>
                                            {/* Suboptions */}
                                            {obj.isSelected &&
                                                obj.description ===
                                                    'Advanced Energy' &&
                                                showCheckboxCode(obj)}
                                            {obj.isSelected &&
                                                obj.description ===
                                                    'Stealth AXiS' &&
                                                showStealthAxisKitCode()}
                                        </Box>
                                    ))}
                                </Grid>
                                <Grid item xs={12} md={isTabletView ? 12 : 6}>
                                    <Box
                                        mb={3}
                                        style={{
                                            marginTop:
                                                isTabletView &&
                                                rightField?.description ===
                                                    'MazorX Robot Used'
                                                    ? '-12px'
                                                    : undefined,
                                        }}
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mb={2}
                                        >
                                            <StyledText
                                                fontSize={SMALL_TEXT_PX}
                                            >
                                                {rightField?.description}
                                            </StyledText>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                            >
                                                <RadioButton
                                                    isChecked={
                                                        rightField.isSelected ===
                                                        true
                                                    }
                                                    id={'report-usage-yes'}
                                                    label={t(
                                                        'reportUsage.record.reportPayment.ReportPayment.yes'
                                                    )}
                                                    handleChange={() => {
                                                        try {
                                                            radioButtonChangeHandler(
                                                                visibleFields,
                                                                visibleFields.findIndex(
                                                                    (f) =>
                                                                        f.code ===
                                                                        rightField.code
                                                                ),
                                                                true
                                                            );
                                                        } catch (error) {
                                                            logErrorToConsole(
                                                                error
                                                            );
                                                        }
                                                    }}
                                                    fontFamilyStyle={
                                                        FONT_FAMILY_REGULAR
                                                    }
                                                    fontSize={BASE_TEXT_PX}
                                                />
                                                <RadioButton
                                                    isChecked={
                                                        rightField.isSelected ===
                                                        false
                                                    }
                                                    id={'report-usage-no'}
                                                    label={t(
                                                        'equity.surgery.notifications.no'
                                                    )}
                                                    handleChange={() => {
                                                        try {
                                                            radioButtonChangeHandler(
                                                                visibleFields,
                                                                visibleFields.findIndex(
                                                                    (f) =>
                                                                        f.code ===
                                                                        rightField.code
                                                                ),
                                                                false
                                                            );
                                                        } catch (error) {
                                                            logErrorToConsole(
                                                                error
                                                            );
                                                        }
                                                    }}
                                                    fontFamilyStyle={
                                                        FONT_FAMILY_REGULAR
                                                    }
                                                    fontSize={BASE_TEXT_PX}
                                                    style={{
                                                        paddingLeft: '28px',
                                                    }}
                                                    width={'14px'}
                                                />
                                            </Box>
                                        </Box>
                                        {/* Suboptions */}
                                        {rightField.isSelected &&
                                            rightField.description ===
                                                'MazorX Robot Used' &&
                                            showMazorRoboticsKitCode(
                                                rightField
                                            )}
                                    </Box>
                                </Grid>
                            </Grid>
                        );
                    }

                    // Default: normal grid, 2 columns
                    return (
                        <Grid container spacing={3}>
                            {visibleFields.map((obj, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    md={
                                        visibleFields.length === 1
                                            ? 12
                                            : isTabletView
                                            ? 12
                                            : 6
                                    }
                                    key={obj.code}
                                    style={{
                                        marginTop:
                                            isDesktopView &&
                                            (obj.code === '3' ||
                                                obj.code === '13') &&
                                            visibleFields.length === 5 &&
                                            !mazorxChecked &&
                                            advancedEnergyCheck
                                                ? '-62.5px'
                                                : '0px',
                                    }}
                                >
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        mb={!isMobileView && 2}
                                    >
                                        <StyledText fontSize={SMALL_TEXT_PX}>
                                            {obj?.description}
                                        </StyledText>
                                        <Box display="flex" alignItems="center">
                                            <RadioButton
                                                isChecked={
                                                    obj.isSelected === true
                                                }
                                                id={`reportPayment-yes-${obj.description}`}
                                                label={t(
                                                    'reportUsage.record.reportPayment.ReportPayment.yes'
                                                )}
                                                handleChange={() => {
                                                    try {
                                                        radioButtonChangeHandler(
                                                            visibleFields,
                                                            index,
                                                            true
                                                        );
                                                    } catch (error) {
                                                        logErrorToConsole(
                                                            error
                                                        );
                                                    }
                                                }}
                                                fontFamilyStyle={
                                                    FONT_FAMILY_REGULAR
                                                }
                                                fontSize={BASE_TEXT_PX}
                                                width={'14px'}
                                            />
                                            <RadioButton
                                                isChecked={
                                                    obj.isSelected === false
                                                }
                                                id={`reportPayment-no-${obj?.description}`}
                                                label={t(
                                                    'equity.surgery.notifications.no'
                                                )}
                                                handleChange={() => {
                                                    try {
                                                        radioButtonChangeHandler(
                                                            visibleFields,
                                                            index,
                                                            false
                                                        );
                                                    } catch (error) {
                                                        logErrorToConsole(
                                                            error
                                                        );
                                                    }
                                                }}
                                                fontFamilyStyle={
                                                    FONT_FAMILY_REGULAR
                                                }
                                                fontSize={BASE_TEXT_PX}
                                                style={{ paddingLeft: '28px' }}
                                                width={'14px'}
                                            />
                                        </Box>
                                    </Box>
                                    {/* Suboptions */}
                                    {obj.isSelected &&
                                        obj.description === 'Advanced Energy' &&
                                        showCheckboxCode(obj)}
                                    {obj.isSelected &&
                                        obj.description ===
                                            'MazorX Robot Used' &&
                                        showMazorRoboticsKitCode(obj)}
                                    {obj.isSelected &&
                                        obj.description === 'Stealth AXiS' &&
                                        showStealthAxisKitCode()}
                                </Grid>
                            ))}
                        </Grid>
                    );
                })()}
        </Box>
    );
};

export default AdditionalProcedureDesktop;

const MazorValidateContainer = styled.div`
    ${media.mediumDevice`
        display: flex;
        justify-content: ${({ justifyContent }) => justifyContent}
    `}
    ${media.smalDevice`
        display: flex;
        justify-content: ${({ justifyContent }) => justifyContent}
    `}
`;
